import React from "react";
import styles from "../../modules/Library/AdverseEvent/css/adverseEvent.module.scss";
import skeletonStyles from "../../assets/scss/common/tableSkeleton.module.scss";

export interface StatCardProps {
  title: string;
  value: React.ReactNode | number;
  subtext: string;
  icon: React.ReactNode;
  bgColor?: string;
  iconColor?: string;
  trendType?: "info" | "negative" | "success";
  subtextIcon?: string;
  loading?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtext,
  icon,
  bgColor = "#ecfdf5",
  iconColor = "#10b981",
  trendType = "info",
  subtextIcon,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className={styles.statCard}>
        <div
          className={skeletonStyles.skeletonLine}
          style={{ width: "36px", height: "36px", borderRadius: "10px", marginBottom: "0.5rem" }}
        />
        <div
          className={skeletonStyles.skeletonLine}
          style={{ width: "50%", height: "15px", marginBottom: "0.5rem" }}
        />
        <div
          className={skeletonStyles.skeletonLine}
          style={{ width: "10%", height: "24px", marginBottom: "0.5rem" }}
        />
        <div
          className={skeletonStyles.skeletonLine}
          style={{ width: "70%", height: "12px" }}
        />
      </div>
    );
  }

  return (
    <div className={styles.statCard}>
      <div
        className={styles.iconWrapper}
        style={{ backgroundColor: bgColor, color: iconColor }}
      >
        {icon}
      </div>
      <div className={styles.label}>{title}</div>
      <div className={styles.value}>{value}</div>
      <div className={`${styles.trend} ${styles[trendType]}`}>
        <i className={subtextIcon ?? "ri-information-line"} />
        {subtext}
      </div>
    </div>
  );
};

export default StatCard;
